export default __webpack_public_path__ + "static/media/vertigo-light.387261d5.jpg";